export const sortByFieldName = (fieldName) => (a, b) => {
  if (a?.[fieldName] < b?.[fieldName]) return -1;
  if (a?.[fieldName] > b?.[fieldName]) return 1;
  return 0;
};

export const deepCompareArrayOfObjects = (arr1, arr2, sortObjectsFieldName) =>
  JSON.stringify(arr1?.sort?.(sortByFieldName(sortObjectsFieldName))) ===
  JSON.stringify(arr2?.sort?.(sortByFieldName(sortObjectsFieldName)));
